import React from 'react';

const PrivacyPolicy = () => {
  const contactEmail = 'hipporasy@gmail.com';
  const effectiveDate = 'February 26, 2026';
  const appName = 'Roguelite';
  const developerName = 'Marasy Phi';

  return (
    <div>
      <h1>Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> {effectiveDate}
      </p>
      <p>
        This Privacy Policy applies to the iOS application <strong>{appName}</strong>, developed
        and maintained by <strong>{developerName}</strong>.
      </p>
      <p>
        This document explains how we handle information in connection with your use of{' '}
        <strong>{appName}</strong>. We are committed to protecting your privacy and operating
        with full transparency.
      </p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          <strong>{appName}</strong> is an iOS game that operates entirely on your local device.
          We do not maintain any backend servers that collect, receive, or process personal data
          from users. This Privacy Policy describes our practices and your rights with respect to
          any information associated with your use of the App.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>

        <h3>Automatically Collected Data</h3>
        <p>
          <strong>{appName}</strong> does not directly collect personal information. However,
          Apple may collect certain technical and diagnostic data as part of the iOS platform in
          accordance with Apple's own privacy practices. This may include device identifiers,
          crash logs, and performance metrics. This data is governed by Apple's Privacy Policy.
        </p>
        <p>
          We do not use any third-party analytics or advertising SDKs. No personal tracking
          is performed by the App.
        </p>

        <h3>Gameplay Data</h3>
        <p>
          Gameplay progress, settings, and preferences are stored locally on your device using
          iOS standard local persistence mechanisms (such as UserDefaults). If you have iCloud
          enabled on your device, this data may be synced across your devices via Apple's iCloud
          service. We do not have access to this data.
        </p>
      </section>

      <section>
        <h2>3. How We Use Information</h2>
        <p>
          Because <strong>{appName}</strong> does not collect personal information, we do not use
          your personal data for any purpose. Local gameplay data is used solely by the App on
          your device to provide and improve your gaming experience, such as saving progress and
          preferences.
        </p>
      </section>

      <section>
        <h2>4. Data Storage and Security</h2>
        <p>
          All data generated by <strong>{appName}</strong> is stored locally on your device. No
          data is transmitted to or stored on external servers operated by us. The security of
          your locally stored data is subject to your device's operating system security
          mechanisms and your own device settings (e.g., passcode, Face ID).
        </p>
        <p>
          If iCloud sync is enabled, your data is stored in your personal iCloud account and is
          protected by Apple's security and encryption standards.
        </p>
      </section>

      <section>
        <h2>5. Third-Party Services</h2>

        <h3>Apple App Store</h3>
        <p>
          <strong>{appName}</strong> is distributed through the Apple App Store. Apple may
          collect information related to your download and purchase activity in accordance with
          Apple's Privacy Policy. All in-app purchases are processed exclusively through Apple's
          StoreKit framework. We do not directly process, store, or have access to your payment
          information.
        </p>

        <h3>iCloud</h3>
        <p>
          If you have iCloud enabled on your device, your gameplay data may be automatically
          synced across your devices using Apple's iCloud service. This sync is managed
          entirely by Apple and governed by Apple's Privacy Policy. You can disable iCloud sync
          at any time through your iOS device settings.
        </p>
      </section>

      <section>
        <h2>6. Children's Privacy</h2>
        <p>
          <strong>{appName}</strong> does not knowingly collect personal information from
          children under the age of 13. The App does not include any features that collect
          personal data, and no user account or registration is required to use the App.
        </p>
        <p>
          If you believe that a child under 13 has somehow provided personal information in
          connection with the App, please contact us so we can take appropriate action. This
          App complies with the Children's Online Privacy Protection Act (COPPA).
        </p>
      </section>

      <section>
        <h2>7. Data Retention</h2>
        <p>
          Because we do not collect personal data, we have no personal data to retain. Locally
          stored gameplay data remains on your device for as long as the App is installed.
          Uninstalling the App will remove all locally stored data from your device. iCloud data
          is managed through your Apple ID and iCloud settings.
        </p>
      </section>

      <section>
        <h2>8. User Rights</h2>
        <p>
          Since <strong>{appName}</strong> does not collect or store personal data on our
          servers, we are unable to fulfill data access, rectification, or deletion requests in
          the traditional sense. You retain full control over your locally stored data:
        </p>
        <ul>
          <li>
            <strong>Delete local data:</strong> Uninstall the App from your device to remove all
            locally stored data.
          </li>
          <li>
            <strong>Manage iCloud data:</strong> Access your iCloud settings on your device to
            manage or delete synced data.
          </li>
          <li>
            <strong>Apple platform rights:</strong> For data collected by Apple (App Store,
            diagnostics), please refer to Apple's Privacy Policy and your Apple ID settings.
          </li>
        </ul>
        <p>
          We do not sell, trade, or otherwise transfer your personal data to third parties.
        </p>
      </section>

      <section>
        <h2>9. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy from time to time to reflect changes in our practices
          or for legal, operational, or regulatory reasons. When we update this Policy, we will
          revise the Effective Date at the top of this document. We encourage you to review this
          Policy periodically. Continued use of the App after any changes constitutes your
          acceptance of the updated Policy.
        </p>
      </section>

      <section>
        <h2>10. Contact Information</h2>
        <p>
          If you have questions, concerns, or requests regarding this Privacy Policy or our
          privacy practices, please contact us at:
        </p>
        <p>
          <strong>Email:</strong>{' '}
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
